module.exports = __webpack_public_path__ + "static/media/spell-check.a5d84843.svg";